// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"482":"0824817b","637":"a0c63b4b"}[chunkId] + ".chunk.css";
};